export const STORE_CHANGED_EVENT = "store:changed"

/**
 * Type definition for the event bus
 */
interface EventBus {
    $on: (event: string, callback: (...args: any[]) => void) => void
    $off: (event: string, callback: (...args: any[]) => void) => void
    $emit: (event: string, ...args: any[]) => void
}

/**
 * A composable to handle store changes using the event bus
 * This allows components to subscribe to store changes without watchers
 */
export function useStoreChanges() {
    const nuxtApp = useNuxtApp()
    const $bus = nuxtApp.$bus as EventBus

    /**
     * Subscribe to store changes
     * @param callback Function to execute when store changes
     */
    function onStoreChange(callback: () => void) {
        $bus.$on(STORE_CHANGED_EVENT, callback)
        // Return a function to unsubscribe
        return () => {
            $bus.$off(STORE_CHANGED_EVENT, callback)
        }
    }

    /**
     * Attach the callback to the component's lifecycle
     * This will automatically unsubscribe when the component is unmounted
     * @param callback Function to execute when store changes
     */
    function useStoreChangeEffect(callback: () => void) {
        if (process.client) {
            const unsubscribe = onStoreChange(callback)
            onUnmounted(() => {
                unsubscribe()
            })
        }
    }

    return {
        onStoreChange,
        useStoreChangeEffect,
    }
}
